var map = {
	"./Svg/Svg": "a2af",
	"./Svg/Svg.pcss": "55c5",
	"./Svg/Svg.ts": "a2af",
	"./Svg/Svg.vue": "72d5",
	"./base-component": "0495",
	"./base-component.ts": "0495"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a89";